import type { IconData } from '@stacksjs/iconify-core'

export const microsoft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 2h9.503v9.503H2zm10.493 0h9.503v9.503h-9.503zM2 12.497h9.503V22H2zm10.493 0h9.503V22h-9.503z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default microsoft
